import { useTranslation } from "react-i18next";

import { useMkTheme } from "@/app/branding";

export function themeOptions(t: (key: string) => string) {
    return [
        { id: "light", label: t("mk.theme.light"), icon: "fa-sun-o" },
        { id: "glass", label: t("mk.theme.glass"), icon: "fa-moon-o" },
        { id: "colorful", label: t("mk.theme.colorful"), icon: "fa-magic" },
    ];
}

export function densityOptions(t: (key: string) => string) {
    return [
        { id: "comfortable", label: t("mk.density.comfortable"), icon: "fa-arrows-v" },
        { id: "compact", label: t("mk.density.compact"), icon: "fa-compress" },
    ];
}

export function sidebarOptions(t: (key: string) => string) {
    return [
        { id: "full", label: t("mk.sidebar.full"), icon: "fa-bars" },
        { id: "icon", label: t("mk.sidebar.icon"), icon: "fa-ellipsis-v" },
    ];
}

export function MkThemeSwitcher({ compact, className }: { compact?: boolean; className?: string }) {
    const { t } = useTranslation();
    const { theme, setTheme } = useMkTheme();
    const classes = ["mk-theme-switch", compact ? "mk-theme-switch-compact" : "", className ?? ""]
        .filter(Boolean).join(" ");
    return (
        <div className={classes}>
            {themeOptions(t).map((option) => (
                <button key={option.id}
                        className={`mk-theme-opt${option.id === theme.theme ? " mk-theme-opt-active" : ""}`}
                        title={option.label} onClick={() => setTheme(option.id)}>
                    <i className={`fa ${option.icon}`} />
                    {!compact && <span className="mk-theme-opt-label">{option.label}</span>}
                </button>
            ))}
        </div>
    );
}
